import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { DomSanitizer } from "@angular/platform-browser";
let SuccessfulRegistrationComponent = class SuccessfulRegistrationComponent {
    constructor(themeService, sanitizer) {
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.textColor = '';
        this.successColor = '';
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.imgLoaded = false;
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
    }
    close() {
        document.body.className = '';
        this.modal.destroy();
    }
};
SuccessfulRegistrationComponent.ctorParameters = () => [
    { type: WebsiteThemeService },
    { type: DomSanitizer }
];
SuccessfulRegistrationComponent = __decorate([
    Component({
        selector: 'app-successful-registration',
        template: __importDefault(require("./successful-registration.component.html")).default,
    })
], SuccessfulRegistrationComponent);
export { SuccessfulRegistrationComponent };
